import { FC } from 'react'
import { SelectOptionItem } from '@components-v2/atoms/SelectOptionItem'
import styles from './index.module.scss'

type Item = {
  instance: {
    id: string
    name: string
  }

  isSelected: boolean
}

type Props = {
  items: Item[]
  onSelect: (id: string) => void
  onUnselect: (id: string) => void
}

export const SelectDropdown: FC<Props> = ({ items, onSelect, onUnselect }) => {
  return (
    <div className={styles.container}>
      {items?.length === 0 && <div className={styles.noResult}>No results found</div>}
      {items?.map(({ isSelected, instance }) => (
        <SelectOptionItem
          key={instance.id}
          item={instance}
          isSelected={isSelected}
          onClick={(e) => {
            e.preventDefault()
            if (isSelected) {
              onUnselect(instance.id)
            } else {
              onSelect(instance.id)
            }
          }}
          labelHtmlFor={instance.name}
        />
      ))}
    </div>
  )
}
